module.exports = __webpack_public_path__ + "static/gmarket-featured-5b22d9d9205f3152f014483c0c3083f9.png";